//Component Colors
export const primaryColor = "#1F44FF";
export const secondaryColor = "#0f0865";
export const sectionPopulationColor = "#EBF8FF";
export const sectionBirthplaceColor = "#EBF8FF";
export const sectionLandSizeColor = "#EBF8FF";
export const sectionGenderColor = "#EBF8FF";
export const sectionPopulationLocationColor = "#EBF8FF";
export const sectionAccommodationColor = "#EBF8FF";
export const sectionLivingConditionColor = "#EBF8FF";
export const sectionResidenceColor = "#EBF8FF";
export const sectionIncomeColor = "#EBF8FF";
export const sectionEmplomentExtentColor = "#EBF8FF";
export const sectionTaxColor = "#EBF8FF";
export const sectionElectionColor = "#EBF8FF";
export const lineColor = "#949494";
export const black = "#151515";
export const messageBoxBackground = "#F8F7F6";
export const mainColor = "#1E00BE";
export const oppositeColor= "#00A362"
